/**
 * MobileCart
 */
function get() {
  if (Array.isArray(window.MobileCart)) {
    return window.MobileCart;
  }

  return [];
}

function set(skuList) {
  if (Array.isArray(window.MobileCart)) {
    window.MobileCart = skuList;
    return true;
  }

  return false;
}

export {
  get,
  set,
};



// WEBPACK FOOTER //
// ./js/mobile/MobileCart.js